import { render, staticRenderFns } from "./Step2Content.vue?vue&type=template&id=9868cece&scoped=true&"
import script from "./Step2Content.vue?vue&type=script&lang=js&"
export * from "./Step2Content.vue?vue&type=script&lang=js&"
import style0 from "./Step2Content.vue?vue&type=style&index=0&id=9868cece&prod&scoped=true&lang=css&"
import style1 from "./Step2Content.vue?vue&type=style&index=1&id=9868cece&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9868cece",
  null
  
)

export default component.exports